export const LOG_EXCEPTION = 0
export const LOG_ADD_ITEM = 1
export const LOG_ADD_RECEIPT = 2
